//import React from 'react'

const AdsPanel = () => {

  return (
    <div>
      <div className='ads-panel'>Right Ads Panel</div>
    </div>
  )
}

export default AdsPanel
